// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-right.v-list-item__content[data-v-3f869692] {\n  justify-content: end;\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
